import { Menu } from '@mui/material';
import React, { ReactNode } from 'react';

export function StyledMenu(props: {
  readonly children: ReactNode;
  readonly anchorEl: HTMLElement | null;
  readonly setAnchorEl: (value: HTMLElement | null) => void;
}) {
  return (
    <Menu
      sx={{
        mt: '45px',
        '& .MuiMenu-paper': {
          background: theme => theme.brandPalette.background.neutral,
          borderRadius: theme => theme.radius.md,
          border: theme => `1px solid ${theme.brandPalette.border.neutralFaded}`
        }
      }}
      id="menu-appbar"
      anchorEl={props.anchorEl}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right'
      }}
      keepMounted
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right'
      }}
      open={Boolean(props.anchorEl)}
      onClose={() => {
        props.setAnchorEl(null);
      }}
    >
      {props.children}
    </Menu>
  );
}
